export const APPLE_STORE_LINK = 'https://apps.apple.com/us/app/walkabout-app/id1661794876';
export const GOOGLE_STORE_LINK = 'https://play.google.com/store/apps/details?id=app.walkabout.my.twa';
